import { useCallback, useRef } from 'react';

export default function useAttachMediaProps() {
  const inputRef = useRef<HTMLInputElement>(null);

  const onAddAttachments = useCallback(() => {
    inputRef.current?.click();
  }, []);

  return {
    inputRef,
    onAddAttachments,
  };
}
